import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown } from '@material-ui/icons';

const { Option } = Select;

type PrizeDrawsFilterType = {
  searchText: string;
  handleSearch: (e: any) => void;
  onAvailableFilter: (e: string) => void;
  onSort: (e: string) => void;
  onApplyFilter: () => void;
};

const PrizeDrawsFilter: React.FC<PrizeDrawsFilterType> = ({
  searchText,
  handleSearch,
  onAvailableFilter,
  onSort,
  onApplyFilter,
}) => {
  const [selectedFilterStatus, setSelectedFilterStatus] = useState<string>('');
  const [selectedSortedStatus, setSelectedSortedStatus] = useState<string>('');
  const intl = useIntl();
  const agentAvailable = [
    { value: '', label: intl.formatMessage({ id: 'All states' }) },
    { value: 'DRAFT', label: intl.formatMessage({ id: 'draw_status_draft' }) },
    { value: 'READY', label: intl.formatMessage({ id: 'draw_status_ready' }) },
    { value: 'SPINNING', label: intl.formatMessage({ id: 'draw_status_spinning' }) },
    { value: 'COMPLETED', label: intl.formatMessage({ id: 'draw_status_completed' }) },
    { value: 'CANCELLED', label: intl.formatMessage({ id: 'draw_status_cancelled' }) },
  ];

  const agentSorts = [
    { value: 'Idesc', label: intl.formatMessage({ id: 'ID (desc)' }) },
    { value: 'Iasc', label: intl.formatMessage({ id: 'ID (asc)' }) },
    { value: 'Ddesc', label: intl.formatMessage({ id: 'Date (Newest first)' }) },
    { value: 'Dasc', label: intl.formatMessage({ id: 'Date (Oldest first)' }) },
  ];

  const handleAvailableFilter = (value: string) => {
    setSelectedFilterStatus(value);
    onAvailableFilter(value);
  };

  const handleSort = (value: string) => {
    setSelectedSortedStatus(value);
    onSort(value);
  };

  const sortOptions = agentSorts.map(item => {
    let isDisabled = false;

    if (selectedFilterStatus && selectedFilterStatus !== '') {
      isDisabled = item.value !== 'Ddesc' && item.value !== 'Dasc' && item.value !== 'Idesc' && item.value !== 'Iasc';
    }

    return (
      <Option
        value={item.value}
        key={item.label}
        disabled={isDisabled}
        style={{ fontFamily: 'Lato', color: '#242c40' }}
      >
        {item.label}
      </Option>
    );
  });

  const filterOptions = agentAvailable.map(item => {
    let isDisabled = false;

    if (selectedSortedStatus === 'Sdesc' || selectedSortedStatus === 'Sasc') {
      isDisabled = item.value !== '';
    }

    return (
      <Option
        value={item.value}
        key={item.label}
        disabled={isDisabled}
        style={{ fontFamily: 'Lato', color: '#242c40' }}
      >
        {item.label}
      </Option>
    );
  });

  return (
    <div className="prizeDraws_filter_layout" id="prizeDraws_filter_layout">
      <Select
        className="availability_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Status' })}
        onChange={handleAvailableFilter}
        id="prizeDraw_status_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {filterOptions}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Sort by' })}
        onChange={handleSort}
        id="prizeDraw_name_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {sortOptions}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter} id="prizeDraw_apply_filters_btn">
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder={intl.formatMessage({ id: 'Search prize draw' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => handleSearch(e)}
        id="prizeDraw_search_input"
        maxLength={200}
      />
    </div>
  );
};

export default PrizeDrawsFilter;
